import { useState } from "react";

import { useLocation } from "react-router-dom";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { useSingleBrandCampaignListData } from "./hooks/useBrandCampaign";
import { Card, CardBody } from "reactstrap";
import Loader from "../../Layout/Loader/Loader";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { showToast } from "../../utils/toastUtils";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import axiosInstance from "../../Api/axiosInstance";
import { COLORS } from "../../constants/colors";
// import Loader from "../../assets/loader/loader.gif";

type Props = {};

function BrandCampaignView({}: Props) {
  const location = useLocation();
  const { startPolling, stopPolling } = useExcelPolling();
  
  const { rowData } = location?.state || {};
 const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");

  const {
    data: singleBrandCampaignData,
    isLoading: singleBrandCampaignLoading,
  } = useSingleBrandCampaignListData({
    id: rowData?.BrandCampiagnId,
    enable: !!rowData?.BrandCampiagnId,
  });

  const processedData = singleBrandCampaignData?.data && [
    {
      ...singleBrandCampaignData?.data,
      DesignationNames: singleBrandCampaignData?.data?.Designations?.map(
        (d: any) => d?.Designation
      ).join(", "),
      BrandNames: singleBrandCampaignData?.data?.FocusBrandsArray?.map(
        (b: any) => b?.BrandName
      ).join(", "),
      SgpiBrandNames: singleBrandCampaignData?.data?.SgpiBrandsArray?.map(
        (b: any) => b?.BrandName
      ).join(", "),
      PositionNames: singleBrandCampaignData?.data?.Positions?.map(
        (p: any) => p.PositionName
      ).join(", "),
      Classifications:
        singleBrandCampaignData?.data?.BrandCampaignClassification?.map(
          (c: any) => c.Classification?.Classification
        ).join(", "),
      IsSuspendedText:
        singleBrandCampaignData?.data?.IsSuspended === 1 ? "Yes" : "No",
    },
  ];

  const campaign = processedData?.[0];
  if (singleBrandCampaignLoading || !campaign) return <Loader />;


  
  const downloadExcelGet = async () => {
    const id:number = rowData?.BrandCampiagnId;
    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.BRAND_CAMPAIGN.GET_BRAND_CAMPAIGN_LIST_EXCE}/${id}`
      );
      const { success, fileDownloadId, intervalTime } = response?.data?.data || null;
      
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus('Loading..');
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) =>{ 
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          }
        });
      }
    } catch (err: any) {
      showToast.error(err);
    }
  };

  return (
    <div style={{ padding: "8px" }}>
      <PageHeader
        title="View Campaign"
        buttons={[
          {
            label: loadingExcel? excelStatus ? excelStatus.charAt(0).toUpperCase() + excelStatus.slice(1) +"..": "": "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
           },
        ]}
      />

      <Card>
        <CardBody>
          <p style={{ fontWeight: "700", fontSize: "18px", color: "#0748A3" }}>
            Campaign Basic Details
          </p>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "10px",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <div>
              <p style={{ fontWeight: "500" }}>Campaign Name</p>
              <p style={{ fontWeight: "600", fontSize: "16px" }}>
                {campaign?.CampiagnName || "-"}
              </p>
            </div>
            <div>
              <p style={{ fontWeight: "500" }}>Campaign Code</p>
              <p style={{ fontWeight: "600", fontSize: "16px" }}>
                {campaign?.BrandCampiagnCode || "-"}
              </p>
            </div>
            <div>
              <p style={{ fontWeight: "500" }}>Outlet Type</p>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "16px",
                  color: "#53BFB9",
                }}
              >
                {campaign?.OutletType?.OutlettypeName || "-"}
              </p>
            </div>
            <div>
              <p style={{ fontWeight: "500" }}>Start Date</p>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "16px",
                }}
              >
                {new Date(campaign?.StartDate).toLocaleDateString() || "-"}
              </p>
            </div>
            <div>
              <p style={{ fontWeight: "500" }}>End Date</p>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "16px",
                }}
              >
                {new Date(campaign?.EndDate).toLocaleDateString() || "-"}
              </p>
            </div>
            <div>
              <p style={{ fontWeight: "500" }}>Locking Date</p>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "16px",
                }}
              >
                {new Date(campaign?.LockingDate).toLocaleDateString() || "-"}
              </p>
            </div>
          </div>

          <div
            style={{
              marginTop: "10px",
            }}
          >
            <p style={{ fontWeight: "500" }}>Description</p>
            <p style={{ fontWeight: "600", fontSize: "16px" }}>
              {campaign?.Description || "-"}
            </p>
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <p style={{ fontWeight: "700", fontSize: "18px", color: "#0748A3" }}>
            Campaign Employee
          </p>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "10px",
              justifyContent: "space-between",
              alignItems: "start",
              margin: "0px 5px",
            }}
          >
            <div style={{ width: "20%" }}>
              <p style={{ fontWeight: "600" }}>Org Unit</p>
              <p style={{ fontWeight: "500", fontSize: "16px" }}>
                {campaign?.UnitName || "-"}
              </p>
            </div>
            <div style={{ width: "47%" }}>
              <p style={{ fontWeight: "600" }}>Designation</p>
              <p style={{ fontWeight: "500", fontSize: "16px" }}>
                {campaign?.DesignationNames || "-"}
              </p>
            </div>
            <div style={{ width: "33%" }}>
              <p style={{ fontWeight: "600" }}>Position</p>
              <p
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                  // color: "#53BFB9",
                }}
              >
                {campaign?.PositionNames || "-"}
              </p>
            </div>
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <p style={{ fontWeight: "700", fontSize: "18px", color: "#0748A3" }}>
            Campaign Configuration
          </p>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "10px",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <div style={{ width: "20%" }}>
              <p style={{ fontWeight: "600" }}>Material URL</p>
              <p style={{ fontWeight: "500", fontSize: "16px" }}>
                {campaign?.Material || "-"}
              </p>
            </div>
            <div style={{ width: "20%" }}>
              <p style={{ fontWeight: "600" }}>Focus Brands</p>
              <p style={{ fontWeight: "500", fontSize: "16px" }}>
                {campaign?.BrandNames || "-"}
              </p>
            </div>
            <div style={{ width: "20%" }}>
              <p style={{ fontWeight: "600" }}>SGPI Brands</p>
              <p style={{ fontWeight: "500", fontSize: "16px" }}>
                {campaign?.SgpiBrandNames || "-"}
              </p>
            </div>
            <div style={{ width: "20%" }}>
              <p style={{ fontWeight: "600" }}>Is Suspended</p>
              <p
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                  // color: "#53BFB9",
                }}
              >
                {campaign?.IsSuspendedText || "-"}
              </p>
            </div>
            <div style={{ width: "20%" }}>
              <p style={{ fontWeight: "600" }}>Outlet Type</p>
              <p
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                  // color: "#53BFB9",
                }}
              >
                {campaign?.OutletType?.OutlettypeName || "-"}
              </p>
            </div>
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <p style={{ fontWeight: "700", fontSize: "18px", color: "#0748A3" }}>
            Campaign Classification
          </p>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "10px",
              borderRadius: "8px",
              overflow: "hidden",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
            }}
          >
            <thead style={{ backgroundColor: "#f9f9f9" }}>
              <tr>
                <th
                  style={{
                    padding: "12px",
                    textAlign: "left",
                    fontWeight: "600",
                    color: "#333",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  Classification
                </th>
                <th
                  style={{
                    padding: "12px",
                    textAlign: "left",
                    fontWeight: "600",
                    color: "#333",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  Minimum
                </th>
                <th
                  style={{
                    padding: "12px",
                    textAlign: "left",
                    fontWeight: "600",
                    color: "#333",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  Maximum
                </th>
              </tr>
            </thead>
            <tbody>
              {campaign?.BrandCampaignClassification?.map(
                (item: any, index: number) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#fff" : "#f5f5f5",
                    }}
                  >
                    <td
                      style={{
                        padding: "12px",
                        borderBottom: "1px solid #eee",
                        color: "#333",
                      }}
                    >
                      {item?.Classification?.Classification || "-"}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        borderBottom: "1px solid #eee",
                        color: "#333",
                      }}
                    >
                      {item?.Minimum ?? 0}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        borderBottom: "1px solid #eee",
                        color: "#333",
                      }}
                    >
                      {item?.Maximum ?? 0}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </CardBody>
      </Card>
    </div>
  );
}

export default BrandCampaignView;

const brandCampaignBasicDetails = [
  {
    name: "Campaign Name",
    selector: (row: { CampiagnName: string }) => row.CampiagnName ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Campaign Code",
    selector: (row: { BrandCampiagnCode: string }) =>
      row.BrandCampiagnCode ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Description",
    selector: (row: { Description: string }) => row.Description ?? "-",
    sortable: true,
    wrap: true,
    width: "180px",
    // wrap: true,
  },
  {
    name: "Campaign Type",
    selector: (row: { CampiagnType: string }) => row.CampiagnType ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Outlet Type",
    selector: (row: { outlettype: string }) => row.outlettype ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
];

const brandCampaignDates = [
  {
    name: "Start Date",
    selector: (row: { StartDate: string }) => row.StartDate ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "End Date",
    selector: (row: { EndDate: string }) => row.EndDate ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Locking Date",
    selector: (row: { LockingDate: string }) => row.LockingDate ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
];

const brandCampaignConfigurations = [
  {
    name: "Material URL",
    selector: (row: { Material: string }) =>
      (row?.Material || row?.Material === "") ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Focus Brands",
    selector: (row: { BrandNames: string }) => row.BrandNames ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "SGPI Brands",
    selector: (row: { SgpiBrandNames: string }) => row.SgpiBrandNames ?? "-",
    sortable: true,
    wrap: true,
    width: "180px",
    // wrap: true,
  },

  {
    name: "Is Suspended",
    selector: (row: { IsSuspendedText: string }) => row.IsSuspendedText ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Outlet Type",
    selector: (row: { LockingDate: string }) => row.LockingDate ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
];

const brandCampaignClassifications = [
  {
    name: "Classification",
    selector: (row: any) => row?.Classification?.Classification ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Minimum",
    selector: (row: { Maximum: string }) => row.Maximum ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Maximum",
    selector: (row: { Minimum: string }) => row.Minimum ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
];

const brandCampaignEmployees = [
  {
    name: "Org Units",
    selector: (row: { UnitName: string }) => row.UnitName ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Designation",
    selector: (row: { DesignationNames: string }) =>
      row.DesignationNames ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Position",
    selector: (row: { PositionNames: string }) => row.PositionNames ?? "-",
    sortable: true,
    wrap: true,
    width: "180px",
    // wrap: true,
  },
];
